<select class="p-2 rounded-3 m-3" [(ngModel)]="selectedDepartement" (ngModelChange)="selectDepartement()">
    <option *ngFor="let departement of departements" [ngValue]="departement">
        {{ departement.code }} {{ departement.name }}
    </option>
</select>

<ng-template [ngIf]="selectedDepartement">
    <button class="p-2 border-0 bg-primary rounded-3 text-white">Télécharger</button>
</ng-template>